<template>
  <vue-scroll>
    <div class="flex justify-flex-end">
      <rabbey-toolbox :filterables="true" @filter-search="search = $event">
        <div class="box mr-15">
          <el-button
            size="mini"
            type="primary"
            round
            icon="el-icon-plus"
            @click="callNew"
            >New Company</el-button
          >
        </div>
      </rabbey-toolbox>
    </div>

    <el-row>
      <el-col>
        <rabbey-table2
          ref="companyTable"
          index-url="/api/Companies"
          :search="search"
          key-search="Name"
          :columns="companyColumns"
          :actions="companyActions"
          :defaultParams="defaultParams"
          :paginateFromApi="false"
          @rtable-push-action="onPushAction"
        />
      </el-col>
    </el-row>

    <NewCompany ref="newCompany" />
    <CompanyDetails ref="companyDetails" />
    <DialogNewBranchOffices ref="subCompany" :companyId="this.companyId" />
  </vue-scroll>
</template>

<script>
import NewCompany from "../../components/Company/NewCompany";
import CompanyDetails from "../../components/Company/CompanyDetails";
import DialogNewBranchOffices from "../../components/Company/DialogSubCompany.vue";

export default {
  name: "Companies",
  components: {
    NewCompany,
    CompanyDetails,
    DialogNewBranchOffices
  },

  data() {
    return {
      loading: false,
      search: "",
      value: "",
      title: "",
      isView: false,
      isEdit: false,
      companyId: 0,

      companyColumns: [
        {
          prop: "Code",
          name: "Code",
          sortable: true
        },
        {
          prop: "Name",
          name: "Name",
          sortable: true
        },
        {
          prop: "Contact",
          name: "Contact",
          sortable: true
        },
        {
          prop: "Telephone1",
          name: "Phone Number"
        },
        {
          prop: "CompanyDatabaseName",
          name: "Database Name"
        }
      ],
      companyActions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "viewCompany"
        },
        {
          icon: "el-icon-edit",
          label: "Edit Company",
          command: "editCompany"
        },
        {
          icon: "el-icon-delete",
          label: "Delete Company",
          command: "deleteCompany"
        },
        {
          icon: "el-icon-office-building",
          label: "Add Branch Offices",
          command: "addBranchOffice"
        }
      ],

      listView: [
        {
          icon: "el-icon-s-grid",
          component: () => import("@/components/prospects/ProspectCards.vue")
        },
        {
          icon: "mdi mdi-table-of-contents",
          component: () => import("@/components/prospects/ProspectTable.vue")
        }
      ]
      // headers: HEADERS,
      // actions: ACTIONS,
    };
  },
  computed: {
    // Set Default Company
    defaultParams() {
      return {
        status: 0,
        companyCode: this.currentCompany
      };
    }
  },
  methods: {
    callNew() {
      this.$refs.newCompany.showCompany(true, "Create Company", false, true);
    },
    onPushAction(options) {
      switch (options.command) {
        case "viewCompany":
          this.$refs.companyDetails.showCompany(options.row);
          break;
        case "addBranchOffice":
          this.companyId = options.row.Id;
          this.$refs.subCompany.showModal(null);
          break;
        case "deleteCompany":
          this.$confirm("Segura/o que desea eliminar este registro ?")
            .then(() => {
              try {
                this.$http
                  .delete(`/api/companies/${options.row.Id}`, this.companyData)
                  .then(() => {
                    this.$message.success("Company Deleted Sucessfully.");
                  })
                  .catch((error) => {
                    console.error(error);
                    this.$message.error("Error Trying Delete Company.");
                  })
                  .finally(() => {
                    this.loading = false;
                  });
              } catch (error) {
                console.error(error);
                this.$message.error("Error Trying Delete Company.");
              }
            })
            .catch(() => {
              this.$message.info("Operation Canceled");
            });
          break;
        case "editCompany":
          this.$refs.newCompany.editCompany(
            options,
            "Edit Company",
            false,
            true
          );
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style></style>
